import { useMemo } from 'react';
import type { ItemTypeLevelOption, ItemTypeOption } from 'src/lib/api/types/loop-visualization';

export const useTimelineItemLevels = ({
  itemLevelId,
  itemTypes,
  itemLevels,
}: {
  itemLevelId: number | null | undefined;
  itemTypes: ItemTypeOption[];
  itemLevels: ItemTypeLevelOption[];
}): {
  curLevelItemTypes: ItemTypeOption[];
  nextLevelItemTypes: ItemTypeOption[];
} => {
  return useMemo(() => {
    if (!itemLevelId || !itemTypes || !itemLevels) {
      return { curLevelItemTypes: [], nextLevelItemTypes: [] };
    }

    const sortedByLevel = [...itemLevels].sort((a, b) => a.level - b.level);
    const curItemLevelIndex = sortedByLevel.findIndex((level) => level.id === itemLevelId);
    const nextItemLevel =
      curItemLevelIndex !== -1 && curItemLevelIndex + 1 < sortedByLevel.length
        ? sortedByLevel[curItemLevelIndex + 1]
        : undefined;
    const nextItemLevelId = nextItemLevel?.id;

    return {
      curLevelItemTypes: itemTypes.filter((itemType) => itemType.itemLevelId === itemLevelId),
      nextLevelItemTypes: itemTypes.filter(
        (itemType) =>
          itemType.itemLevelId && nextItemLevelId && itemType.itemLevelId === nextItemLevelId,
      ),
    };
  }, [itemLevelId, itemTypes, itemLevels]);
};
